// extracted by mini-css-extract-plugin
export var container = "_c6-0";
export var popoverContent = "_c6-1";
export var tosLink = "_c6-2";